import { render } from "./IntroductionPage.vue?vue&type=template&id=061556bd&scoped=true"
import script from "./IntroductionPage.vue?vue&type=script&lang=js"
export * from "./IntroductionPage.vue?vue&type=script&lang=js"

import "./IntroductionPage.vue?vue&type=style&index=0&id=061556bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061556bd"]])

export default __exports__